import { BaseApiService } from '~/services/base-api.service';
import { IApiService } from '~/services/interfaces/IApiService';

export class S3ApiAdapter extends BaseApiService implements IApiService {
    protected getBaseUrl() {
        return process.env.S3_BASE_URL;
    }

    getHeaders(): Record<string, string> {
        return {};
    }
}
